import ErrorBoundary from "components/ErrorBoundary";
import React, { useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import SearchContainer from "./SearchContainer";
import RxManagerTable from "./RxManagerTable";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useContextService from "hooks/useContextService";
import useAxios from "hooks/useAxios";
import SbDetailsTable from "pages/SbReports/SbReportsTables/SbDetailsTable";


const RxManager = (props) => {
    const { module, orgId } = props;

    const API = useAxios();
    const [collapseSider, setcollapseSider] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [detailsData, setDetailsData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const {
        states: { rxManager },
        setStates,
        resetStates,
    } = useContextService();
    const { search, coveredEntities, searchTerms, accumulations } = rxManager;



    let {
        startDate,
        encounter,
        accumulationIDs,
    } = searchTerms;


    const toggleSider = () => {
        debugger;
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        } else {
            setCollIcon(faAngleUp);
        }
    };
    const handleSearch = async (filter) => {
        debugger;
        const {
            accumulationIDs,
            coveredEntityIDs,
            startDate,
            dateRangeID,
            acccountype,
            report,
            endDate,
            encounter
        } = filter;
        // setReportType(report);
        search.CeIdS = coveredEntityIDs;
        search.AccumulationIDs = accumulationIDs;
        search.StartDate = startDate;
        search.EndDate = endDate;
        search.DateRangeID = 0;
        search.Report = 'utilizationData';
        search.Accountype = acccountype;
        search.EnCounter = encounter
        // updateStates(rxManager);
        await fetchUtilizationsummeryList(search);


    };
    const fetchUtilizationsummeryList = async (filters) => {
        debugger;
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/RxManagerAll/`, filters,
                { hasDefaultURL: true, }
            )
            if (data) {
                setDetailsData(data.items);
                setTotalItem(data.totalRecords);
                // toggleSider();
            }
            else {
                setDetailsData([]);
            }

        }
        catch {

        }

    }
    const onreset = ()=>{
              setDetailsData([]);
    }
    return (
        <div>
            <Container fluid className="width_info">
                <div className={collapseSider ? "mb-0" : "mb-3"}>
                    <Card hidden={collapseSider} className='border-0 shadow-top'>
                        <CardBody >
                            <ErrorBoundary>
                                <SearchContainer orgId={orgId} reset={onreset} onSearch={handleSearch} />
                            </ErrorBoundary>
                        </CardBody>
                    </Card>
                </div>
                <Card className="mt-3">
                    <CardBody className="section-devider-border">
                        <ErrorBoundary>
                            <RxManagerTable toggleSider={toggleSider}   totalItem={totalItem} reportType='utilizationData' detailsData={detailsData} orgId={orgId} search={search} />

                            {/* <RxManagerTable toggleSider={toggleSider} orgId={orgId}  search = {search}/> */}
                        </ErrorBoundary>
                    </CardBody>
                </Card>
            </Container>
        </div>

    )

}
export default RxManager;
